export default __webpack_public_path__ + "static/media/awraaq2.ca5e0328.png";